module.exports = __webpack_public_path__ + "assets/gradientbg-3157e365c55fb878435556de91579f07.png";


//////////////////
// WEBPACK FOOTER
// ./button/libs/mfButtons/images/gradientbg.png
// module id = 60
// module chunks = 4